import { FC } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import Button from 'jbc-front/components/Button';
import { Edit } from 'jbc-front/components/icons';
import Select, { StylesConfig } from 'react-select-5.7.0';
import { Panel } from '@/components/PrimaryPanel';
import { dateFormat } from '@/components/utils/formatter';
import { makeBackUrl } from '@/utils/url';
import { Employee, PartialRegularHealthCheckupResult } from '../../query';
import styles from './PersonalResults.scss';

const selectStyles: StylesConfig = {
  dropdownIndicator: provided => ({
    ...provided,
    width: '30px'
  }),
  container: provided => ({ ...provided, display: 'inline-block', marginLeft: '30px' }),
  control: provided => ({ ...provided, boxShadow: 'initial', width: '140px', height: '38px' }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '0 8px'
  }),
  menu: styles => ({
    ...styles,
    margin: '0px',
    borderRadius: '0px 0px 4px 4px',
    boxShadow: 'none',
    borderRight: '1px solid #ccc',
    borderLeft: '1px solid #ccc',
    borderBottom: '1px solid #ccc'
  }),
  menuList: styles => ({
    ...styles,
    padding: 0,
    maxHeight: '140px',
    overflow: 'auto'
  }),
  menuPortal: styles => ({
    ...styles,
    '&:hover': {
      backgroundColor: '#EBF4FF'
    }
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? '#EBF4FF' : styles['backgroundColor'],
    color: isSelected ? '#333' : styles['color'],
    minHeight: '38px'
  })
};

interface PersonalResultsProps {
  employee: Employee;
  results: PartialRegularHealthCheckupResult[];
  currentResultId?: string;
}

export const PersonalResults: FC<PersonalResultsProps> = ({ employee, results, currentResultId }) => {
  const location = useLocation();
  const history = useHistory();
  const options = results.map(result => ({ value: result.id, label: dateFormat(result.dateOn, 'YYYY/M/D') }));

  return (
    <Panel className={styles.panel}>
      <div className={styles.item}>
        <div className={styles.selectWrap}>
          健康診断実施日
          <Select
            styles={selectStyles}
            options={options}
            placeholder=""
            noOptionsMessage={() => ''}
            isDisabled={options.length === 0}
            value={options.find(opt => opt.value === currentResultId)}
            onChange={(newValue: any) => {
              if (newValue) {
                history.push(`/regular_health_checkup/personal_results/${employee.personalId}/${newValue.value}`);
              }
            }}
          />
        </div>
        <div className={styles.actions}>
          <Button
            icon={<Edit />}
            as={Link}
            to={`/regular_health_checkup/personal_results/${employee.personalId}/delete`}
            widthAuto>
            過去の診断結果を削除
          </Button>
          <Button
            as={Link}
            to={`/regular_health_checkup/personal_results/${employee.personalId}/create?back_to=${makeBackUrl(location)}`}
            primary
            widthAuto>
            健康診断結果の追加
          </Button>
        </div>
      </div>
    </Panel>
  );
};
